/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {PositionStrategy} from './position/position-strategy';
import {Direction} from '@angular/cdk/bidi';
import {ScrollStrategy} from './scroll/scroll-strategy';
import {NoopScrollStrategy} from './scroll/noop-scroll-strategy';
/**
 * OverlayState is a bag of values for either the initial configuration or current state of an
 * overlay.
 */
export class OverlayState {
/**
 * Strategy with which to position the overlay.
 */
positionStrategy: PositionStrategy;
/**
 * Strategy to be used when handling scroll events while the overlay is open.
 */
scrollStrategy: ScrollStrategy = new NoopScrollStrategy();
/**
 * Custom class to add to the overlay pane.
 */
panelClass?: string | string[] = '';
/**
 * Whether the overlay has a backdrop.
 */
hasBackdrop?: boolean = false;
/**
 * Custom class to add to the backdrop
 */
backdropClass?: string = 'cdk-overlay-dark-backdrop';
/**
 * The width of the overlay panel. If a number is provided, pixel units are assumed.
 */
width?: number | string;
/**
 * The height of the overlay panel. If a number is provided, pixel units are assumed.
 */
height?: number | string;
/**
 * The min-width of the overlay panel. If a number is provided, pixel units are assumed.
 */
minWidth?: number | string;
/**
 * The min-height of the overlay panel. If a number is provided, pixel units are assumed.
 */
minHeight?: number | string;
/**
 * The max-width of the overlay panel. If a number is provided, pixel units are assumed.
 */
maxWidth?: number | string;
/**
 * The max-height of the overlay panel. If a number is provided, pixel units are assumed.
 */
maxHeight?: number | string;
/**
 * The direction of the text in the overlay panel.
 */
direction?: Direction = 'ltr';

  // TODO(jelbourn): configuration still to add
  // - focus trap
  // - disable pointer events
  // - z-index
}

function OverlayState_tsickle_Closure_declarations() {
/**
 * Strategy with which to position the overlay.
 * @type {?}
 */
OverlayState.prototype.positionStrategy;
/**
 * Strategy to be used when handling scroll events while the overlay is open.
 * @type {?}
 */
OverlayState.prototype.scrollStrategy;
/**
 * Custom class to add to the overlay pane.
 * @type {?}
 */
OverlayState.prototype.panelClass;
/**
 * Whether the overlay has a backdrop.
 * @type {?}
 */
OverlayState.prototype.hasBackdrop;
/**
 * Custom class to add to the backdrop
 * @type {?}
 */
OverlayState.prototype.backdropClass;
/**
 * The width of the overlay panel. If a number is provided, pixel units are assumed.
 * @type {?}
 */
OverlayState.prototype.width;
/**
 * The height of the overlay panel. If a number is provided, pixel units are assumed.
 * @type {?}
 */
OverlayState.prototype.height;
/**
 * The min-width of the overlay panel. If a number is provided, pixel units are assumed.
 * @type {?}
 */
OverlayState.prototype.minWidth;
/**
 * The min-height of the overlay panel. If a number is provided, pixel units are assumed.
 * @type {?}
 */
OverlayState.prototype.minHeight;
/**
 * The max-width of the overlay panel. If a number is provided, pixel units are assumed.
 * @type {?}
 */
OverlayState.prototype.maxWidth;
/**
 * The max-height of the overlay panel. If a number is provided, pixel units are assumed.
 * @type {?}
 */
OverlayState.prototype.maxHeight;
/**
 * The direction of the text in the overlay panel.
 * @type {?}
 */
OverlayState.prototype.direction;
}




// WEBPACK FOOTER //
// ../../../src/cdk/overlay/overlay-state.ts